<lib-permissions-page (complete)="goToHome()" [permissions]="['location']"></lib-permissions-page>